import React from "react";
import "./dateGroup.scss";

/**
 * Date Group Header Component
 * @param {string} date - Date string (YYYY-MM-DD format)
 */
const DateGroup = ({ date }) => {
    const formatDate = (dateString) => {
        const targetDate = new Date(dateString);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        // Reset time part for comparison
        today.setHours(0, 0, 0, 0);
        yesterday.setHours(0, 0, 0, 0);
        targetDate.setHours(0, 0, 0, 0);

        if (targetDate.getTime() === today.getTime()) {
            return "오늘";
        } else if (targetDate.getTime() === yesterday.getTime()) {
            return "어제";
        } else {
            return targetDate.toLocaleDateString("ko-KR", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        }
    };

    return (
        <div className="date-group-header">
            <span className="date-text">{formatDate(date)}</span>
        </div>
    );
};

export default DateGroup;
